import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiSettings, FiGlobe, FiSun, FiMoon, FiFileText } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';

const FooterMobile: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const currentYear = new Date().getFullYear();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
  };

  const openCookieSettings = () => {
    // Reset cookie consent to show banner again
    localStorage.removeItem('guideme-cookie-consent');
    window.location.reload();
  };

  return (
    <div className="border-t border-gray-200 dark:border-gray-700 pt-2 mt-2">
      {/* Language Toggle */}
      <button
        onClick={toggleLanguage}
        className="w-full flex items-center justify-between p-3 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md transition-colors"
      >
        <div className="flex items-center">
          <FiGlobe className="w-4 h-4 mr-3" />
          <span>{i18n.language === 'es' ? 'Idioma: Español' : 'Language: English'}</span>
        </div>
        <span className="text-xs bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
          {i18n.language === 'es' ? 'ES' : 'EN'}
        </span>
      </button>

      {/* Dark Mode Toggle */}
      <button
        onClick={toggleTheme}
        className="w-full flex items-center justify-between p-3 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md transition-colors"
      >
        <div className="flex items-center">
          {theme === 'dark' ? (
            <FiMoon className="w-4 h-4 mr-3" />
          ) : (
            <FiSun className="w-4 h-4 mr-3" />
          )}
          <span>{theme === 'dark' ? 'Modo Oscuro' : 'Modo Claro'}</span>
        </div>
        
        {/* iPhone-style toggle switch */}
        <div 
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out ${
            theme === 'dark' 
              ? 'bg-blue-600' 
              : 'bg-gray-200 dark:bg-gray-700'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out ${
              theme === 'dark' ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </div>
      </button>

      {/* Divider */}
      <div className="border-t border-gray-100 dark:border-gray-800 my-2"></div>

      {/* Legal + Cookies */}
      <div className="space-y-1">
        <Link
          to="/settings#legal-texts"
          className="w-full flex items-center p-3 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md transition-colors"
        >
          <FiFileText className="w-4 h-4 mr-3" />
          Textos legales
        </Link>

        <button
          onClick={openCookieSettings}
          className="w-full flex items-center p-3 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md transition-colors text-left"
        >
          <FiSettings className="w-4 h-4 mr-3" />
          Configurar Cookies
        </button>
      </div>

      {/* Copyright */}
      <div className="mt-2 pt-2 border-t border-gray-100 dark:border-gray-800">
        <div className="flex items-center justify-center text-xs text-gray-500 dark:text-gray-500">
          <span>© {currentYear} GuideMe by</span>
          <a 
            href="https://elevate.com.es" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="ml-2 hover:opacity-80 transition-opacity"
          >
            <img 
              src="/images/logo/elevate.png" 
              alt="Elevate" 
              className="h-[15px] w-auto dark:hidden"
            />
            <img 
              src="/images/logo/elevate-dark.png" 
              alt="Elevate" 
              className="h-[15px] w-auto hidden dark:block"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FooterMobile;